import Pricing from "./Pricing.js";
export default Pricing;
